import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'erp-product-list',
  name: '商品档案',
  icon: '档',
  group: 'ERP 组件',
  description: '展示 ERP 商品、库存和价格。',
  defaultProps: {
    title: '常用商品',
    limit: 8
}
}
